export default __webpack_public_path__ + "static/media/ct2.2.569f6fb2.png";